import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export const getGenders = async () => fetcher.get({ path: '/genders' });
